import SchoolContainer from '../../common/SchoolContainer';

const LecturesContainer = () => <SchoolContainer productType="lectures" />

export default LecturesContainer